import { Card, Descriptions } from 'antd';
import React, { memo } from 'react';

/**
 * Memoized component for displaying applicant personal information
 * @param {Object} props - Component props
 * @param {Object} props.data - Applicant data object
 */
const PersonalInfo = memo(({ data }) => (
    <Card className="mb-4">
        <Descriptions title="Personal Information" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
            <Descriptions.Item label="First Name">{data.firstName}</Descriptions.Item>
            <Descriptions.Item label="Last Name">{data.lastName}</Descriptions.Item>
            <Descriptions.Item label="Middle Name">{data.middleName || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Date of Birth">{data.dob ? new Date(data.dob).toLocaleDateString() : 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Email">{data.email}</Descriptions.Item>
            <Descriptions.Item label="Mobile">{data.mobile || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Nationality">{data.nationality || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Gender">{data.gender || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Religion">{data.religion || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Civil Status">{data.civilStatus || 'N/A'}</Descriptions.Item>
        </Descriptions>
    </Card>
));

export default PersonalInfo;
